import { render } from "./RandomWord.vue?vue&type=template&id=0f6f63a2&scoped=true"
import script from "./RandomWord.vue?vue&type=script&lang=js"
export * from "./RandomWord.vue?vue&type=script&lang=js"

import "./RandomWord.vue?vue&type=style&index=0&id=0f6f63a2&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6f63a2"]])

export default __exports__